export default __webpack_public_path__ + "static/media/Inter-Light.ab15890d.woff2";